import { Component } from '@angular/core';
import { ViewController, AlertController, NavController, NavParams, LoadingController, ToastController, ModalController } from 'ionic-angular';
import { HttpClient } from '../../services/HttpClient';

import { AddFilePage } from '../addFile/addFile';

@Component({
  selector: 'page-image-selector',
  templateUrl: 'imageSelector.html',
  providers: [HttpClient]
})

export class ImageSelector {

    searchQuery = '';

  	viewCtrl: ViewController;
  	navCtrl : NavController;
  	navParams : NavParams;
  	httpClient : HttpClient;
    baseUrl;
  	loadingCtrl : LoadingController;
    alertCtrl : AlertController;
    toastCtrl : ToastController;
    modalCtrl : ModalController;

    loading;

    images;

    isProfile = false;

	constructor(viewCtrl: ViewController,alertCtrl : AlertController, navCtrl: NavController, navParams: NavParams, httpClient : HttpClient, loadingCtrl : LoadingController, toastCtrl : ToastController, modalCtrl : ModalController) {
		this.viewCtrl = viewCtrl;
		this.navParams = navParams;
		this.navCtrl = navCtrl;
		this.httpClient = httpClient;
    this.baseUrl = this.httpClient.getBaseUrl();
    
		this.loadingCtrl = loadingCtrl;
    this.alertCtrl = alertCtrl;
    this.toastCtrl = toastCtrl;
    this.modalCtrl = modalCtrl;
    this.isProfile = this.navParams.get('isProfile')?this.navParams.get('isProfile'):false;
    this.httpCallImages('');
	}

  httpCallImages(name){
    this.httpClient.get('/files?name='+name,(error,data)=>{
      this.images = data.json();
    });
  }

  onClickImage(image){
    this.dismiss(image);
  }

  onSearch(){
    if(this.searchQuery.length > 0){
      this.httpCallImages(this.searchQuery);
    }else{
      this.httpCallImages(this.searchQuery);
    }
  }

  onClickUpload(){
    let modal = this.modalCtrl.create(AddFilePage, {isProfile : this.isProfile});
    modal.onDidDismiss(reload=>{
      if(reload){
        if(reload.filename){
          let image = {filename : reload.filename};
          this.dismiss(image);
        }else{
          this.httpCallImages('');
        }
      }
    });
    modal.present();
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content : 'Guardando la información...'
    });
    this.loading.present();
  }

  hideLoading(){
    this.loading.dismiss();
  }

  dismiss(image){
    this.viewCtrl.dismiss(image);
  }
}



// WEBPACK FOOTER //
// ./src/util/imageSelector/imageSelector.ts